//引入Vue
import Vue from "vue";
//引入Vue-router
import VueRouter from "vue-router";
//使用VueRouter
Vue.use(VueRouter);
//引入路由组件
import Home from "@/components/Home"
import Search from "@/components/Search"
import Theme from "@/components/Theme"
import ResearchUnit from "@/components/ResearchUnit"
import Atlas from "@/components/Atlas"
//对外暴露一个Vue实例
export default new VueRouter({
    mode: 'history',
    //配置路由
    routes:[
        {
            path:'/',
            redirect:'/Home'
        },
        {
            path:'/Home',
            component:Home,
            name:"Home",
            meta:{isshow:true,title:'首页'}
        },
        {
            path:'/Search',
            component:Search,
            name:"Search",
            meta:{isshow:false,title:'搜索'}
        },
        {
            path:'/Theme',
            component:Theme,
            name:"Theme",
            meta:{isshow:false,title:'专题'}
        },
        {
            path:'/ResearchUnit',
            component:ResearchUnit,
            name:"ResearchUnit",
            meta:{isshow:false,title:'研究单元'}
        },
        {
            path:'/Atlas',
            component:Atlas,
            name:"Atlas",
            meta:{isshow:false,title:'知识图普'}
        },
        //重定向
        {
            path:'*',
            redirect:"/Home"
        }
    ]
})